'use strict';

var $ = require('jquery');
var Debouncer = require('../lib/Debouncer.js');
var Cycle = require('../lib/third-party/jquery.cycle.js');

function init() {
	var $carousel = $('.carousel');
	if ($carousel.length === 0) {
		return;
	}
	var minWidth = [];
	var winWidth = window.innerWidth;
	var cycle = [];

	function checkWidth($this, count) {
		winWidth = window.innerWidth;

		if (winWidth < minWidth[count] * count) {
			cycle[count] = $this.cycle({
				speed : 1000,
				slides: '> *',
				setTimeout : 4000
			});
		} else {
			if (cycle[count]){
				cycle[count] = undefined;
				$this.cycle('destroy');
			}
		}
	}

	$carousel.each(function() {
		var $this = $(this);
		var count = $this.data('count');
		minWidth[count] = Number.parseInt($this.find('> *:first-child').css('min-width'));

		checkWidth($this, count);

		$(window).on('resize.' + count, (new Debouncer(function() {
			checkWidth($this, count)
		})).run);
	});
}
module.exports = {
	init : init
};
